import { useEffect } from "react";

const hidden = "hidden";

export const useLockBodyScroll = (locked: boolean): void => {
  useEffect(() => {
    const body = document.querySelector("body");
    const lastOverflow = body!.style.overflow;

    if (locked) {
      body!.style.overflow = hidden;
    }

    return () => {
      body!.style.overflow = lastOverflow === hidden ? "" : lastOverflow;
    };
  }, [locked]);
};
